import { IonIcon } from '@ionic/react';
import React from 'react';

import { constructOutline } from 'ionicons/icons';

import './Maintenance.css';

interface MaintenanceProps {}

const Maintenance: React.FC<MaintenanceProps> = () => {
  return (
    <div className="maintenance">
      <IonIcon icon={constructOutline} />
      <h3>Under Maintenance</h3>
      <p>
        We're currently performing scheduled maintenance. Please check back
        later.
      </p>
    </div>
  );
};

export default Maintenance;
